"use client";

import { WidgetTemplateCategory } from "@/modules/widget-templates";

interface CategorySidebarProps {
    categories: WidgetTemplateCategory[];
    selectedCategory: string | null;
    onSelectCategory: (slug: string | null) => void;
}

export function CategorySidebar({ categories, selectedCategory, onSelectCategory }: CategorySidebarProps) {
    return (
        <div className="w-44 shrink-0 pr-4">
            <p className="mb-3 text-[11px] font-semibold uppercase tracking-wider text-[#5a717a] font-roboto">Categories</p>
            <div className="flex flex-col gap-0.5">
                {categories.map((category) => (
                    <button
                        key={category.id}
                        type="button"
                        onClick={() => onSelectCategory(category.slug)}
                        className={`rounded-r-md px-3 py-2 text-left text-sm font-roboto transition-colors ${
                            selectedCategory === category.slug
                                ? "border-l-[3px] border-[#079a95] bg-[#e8f5f4] font-semibold text-[#079a95]"
                                : "border-l-[3px] border-transparent text-[#2d3a3f] hover:bg-[#f3f5f6]"
                        }`}
                    >
                        {category.name}
                    </button>
                ))}
            </div>
        </div>
    );
}
